module.exports = __webpack_public_path__ + "img/3.ddb7ff88.png";